// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pair[data-v-3c9b2635]{-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}.pair[data-v-3c9b2635],.pair>div[data-v-3c9b2635]{display:-webkit-box;display:-webkit-flex;display:flex}.pair>div.content[data-v-3c9b2635]{-webkit-box-flex:1;-webkit-flex:1;flex:1}", ""]);
// Exports
module.exports = exports;
